"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.member = void 0;
var utils_1 = require("../../utils");
var qs = require('qs');
exports.member = function (axios) {
    return {
        // [Member]
        getMembers: function (getMembersRequest) {
            return axios.get('/members', getMembersRequest);
        },
        getMembersMemberNo: function (request) {
            var url = utils_1.paramPathchange('/members/{memberNo}', request);
            return axios.get(url);
        },
        getMembersMemberNoAccumulations: function (request) {
            var url = utils_1.paramPathchange('/members/{memberNo}/accumulations', request);
            return axios.get(url);
        },
        putMembersMemberNo: function (request) {
            var url = utils_1.paramPathchange('/members/{memberNo}', request);
            return axios.put(url, request.data);
        },
        postMembersMemberNosExcel: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/members/member-nos/excel?" + query, request.data);
        },
        putMembersGrade: function (request) {
            return axios.put('/members/grade', request.data);
        },
        putMembersGroup: function (request) {
            return axios.put('/members/group', request.data);
        },
        getMembersStates: function (getMembersStates) {
            return axios.get('/members/states', getMembersStates);
        },
        getMembersSummary: function (getMembersSummary) {
            return axios.get('/members/summary', getMembersSummary);
        },
        getMembersSummaryV2: function (getMembersSummary) {
            return axios.get('/members/summary', getMembersSummary);
        },
        getMembersEmailDuplicated: function (request) {
            return axios.get('/members/email-duplicated', request);
        },
        postMembersCheckEmail: function (request) {
            return axios.post('/members/check-email', request.data);
        },
        postMembersCheckId: function (request) {
            return axios.post('/members/check-id', request.data);
        },
        postMembersCheckNickname: function (request) {
            return axios.post('/members/check-nickname', request.data);
        },
        // xxx
        postMembersJoinconfig: function (request) {
            return axios.post("/members/join-config?mallNo=" + request.params.mallNo, request.data);
        },
        patchMembersJoinconfig: function (request) {
            return axios.patch("/members/join-config?mallNo=" + request.params.mallNo, request.data);
        },
        /** @deprecated getMembersOpenIdConfig 사용 */
        getMembersOpenidconfig: function (request) {
            return axios.get('/members/open-id-config', request);
        },
        getMembersOpenIdConfig: function (request) {
            return axios.get('/members/open-id-config', request);
        },
        /** @deprecated patchMembersOpenIdConfig 사용 */
        patchMembersOpenidconfig: function (request) {
            return axios.patch("/members/open-id-config?mallNo=" + request.params.mallNo, request.data);
        },
        patchMembersOpenIdConfig: function (request) {
            return axios.patch("/members/open-id-config?mallNo=" + request.params.mallNo, request.data);
        },
        /** @deprecated postMembersOpenIdConfig 사용 */
        postMembersOpenidconfig: function (request) {
            return axios.post("/members/open-id-config?mallNo=" + request.params.mallNo, request.data);
        },
        postMembersOpenIdConfig: function (request) {
            return axios.post("/members/open-id-config?mallNo=" + request.params.mallNo, request.data);
        },
        /** @deprecated postMemberProhibit 사용 */
        postMemberHibit: function (PostMemberHibitRequest) {
            return axios.post('/members/prohibit', PostMemberHibitRequest);
        },
        postMemberProhibit: function (request) {
            if (!request.headers) {
                return axios.post('/members/prohibit', request.data);
            }
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.post('/members/prohibit', request.data, config);
        },
        postMembersResetPassword: function (postMembersResetPasswordRequest) {
            return axios.post('/members/reset-password', postMembersResetPasswordRequest.data);
        },
        getMembersCount: function (getMembersCountRequest) {
            return axios.get('/members/count', getMembersCountRequest);
        },
        postMembers: function (request) {
            return axios.post('/members', request.data);
        },
        putWithdrawalMembersGrade: function (request) {
            return axios.put('/withdrawal-members', request.data);
        },
        patchMembersTempPassword: function (request) {
            return axios.patch('/members/temp-password', request);
        },
        putPendingMembers: function (request) {
            return axios.put('/pending-members', request.data);
        },
        deletePendingMembers: function (request) {
            return axios.delete('/pending-members', request);
        },
        getMembersCommonJoinConfig: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/members/common-join-config?" + query);
        },
        putMembersCommonJoinConfig: function (request) {
            var query = qs.stringify(request.params);
            return axios.put("/members/common-join-config?" + query, request.data);
        },
        getMembersExtraInfoConfig: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/members/extra-info-config?" + query);
        },
        postMembersExtraInfoConfig: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/members/extra-info-config?" + query, request.data);
        },
        getMembersTotalCountSearchByGradeGroup: function (_a) {
            var params = _a.params;
            return axios.get("/members/total-count/search-by-grade-group?" + qs.stringify(params));
        }
    };
};
